module.exports = __webpack_public_path__ + "img/vertical_3_4_3009.f49a3775.png";